import { render, staticRenderFns } from "./IconProofreadDoneSmall.vue?vue&type=template&id=67cbe731&"
import script from "./IconProofreadDoneSmall.vue?vue&type=script&lang=js&"
export * from "./IconProofreadDoneSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67cbe731')) {
      api.createRecord('67cbe731', component.options)
    } else {
      api.reload('67cbe731', component.options)
    }
    module.hot.accept("./IconProofreadDoneSmall.vue?vue&type=template&id=67cbe731&", function () {
      api.rerender('67cbe731', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconProofreadDoneSmall.vue"
export default component.exports